export * from "./static-footer";
